import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import TrackVisibility from "react-on-screen";

import { ProjectCard } from "./ProjectCard";

import colorSharp2 from "../assets/img/color-sharp2.png";
import projImg1 from "../assets/img/projectimgs/project-img1.png";
import projImg2 from "../assets/img/projectimgs/project-img2.png";
import projImg3 from "../assets/img/projectimgs/project-img3.png";
import projImg4 from "../assets/img/projectimgs/project-img4.png";
import projImg5 from "../assets/img/projectimgs/project-img5.png";
import projImg6 from "../assets/img/projectimgs/project-img6.png";
import projImg7 from "../assets/img/projectimgs/project-img7.png";
import projImg8 from "../assets/img/projectimgs/project-img8.png";
import projImg9 from "../assets/img/projectimgs/project-img9.png";
import projImg10 from "../assets/img/projectimgs/project-img10.png";
import projImg11 from "../assets/img/projectimgs/project-img11.png";

import "animate.css";

export const Projects = () => {
  const projects = [
    {
      title: "Music Discord Bot",
      description:
        "Forked Discord Music Bot based on jagrosh’s JMusicBot, enhanced with additional features",
      imgUrl: projImg2,
      link: "https://github.com/BlainBlain/MusicBot",
      category: "personal",
    },
    {
      title: "GOG Achievements Script",
      description:
        "Script for Displaying Achievements in GOG Games Using Achievement Watcher and Nemirtingas GOG Emulator",
      imgUrl: projImg3,
      link: "https://github.com/BlainBlain/GOG_Achievements",
      category: "personal",
    },
    {
      title: "YouTube Music Controls",
      description: "A Vencord plugin to control YouTube Music from Discord",
      imgUrl: projImg11,
      link: "https://github.com/BlainBlain/vc-youtubeMusicControls",
      category: "personal",
    },
    {
      title: "MAMI Discord Bot",
      description:
        "A message relay bot that automatically forwards important messages between channels using Python",
      imgUrl: projImg1,
      link: "https://github.com/BlainBlain/ReplitNews",
      category: "personal",
    },
    {
      title: "Realtor Website Concept",
      description:
        "Sample design prototype for a real estate firm, built with HTML, CSS, and JavaScript.",
      imgUrl: projImg10,
      link: "https://blainblain.github.io/MarciRealtor/",
      category: "personal",
    },
    {
      title: "KeyChase: Arduino-Based Anti-theft Keychain",
      description:
        "Arduino-based keychain with anti-theft alerts and real-time directions via a mobile app.",
      imgUrl: projImg4,
      link: "https://drive.google.com/drive/folders/1_CAfuDk-IBe-HDM15RJQ9zDKxLi7hpJK?usp=drive_link",
      category: "college",
    },
    {
      title: "CueBook: Billiard Table Reservation Software",
      description:
        "Billiard table reservation software that simplifies bookings with real-time updates, user profiles, and a receipt system.",
      imgUrl: projImg5,
      link: "https://drive.google.com/file/d/1uHPz5sW9k9rzywudhX_VYRO0hM73iSmG/view?usp=sharing",
      category: "college",
    },
    {
      title: "Super Shies: Rental Management System for Catering Equipment",
      description:
        "Rental management system designed to streamline the booking, tracking, and management of catering equipment rentals.",
      imgUrl: projImg6,
      link: "https://drive.google.com/file/d/1SLGFjvjVW4G75qDV_D8GTHO4UckrgXQ8/view?usp=sharing",
      category: "college",
    },
    {
      title: "VaPure: CpE Thesis Project",
      description:
        "Sustainable water system using dehumidification, filtration, and solar power to produce potable water.",
      imgUrl: projImg7,
      link: "https://drive.google.com/drive/folders/1xtWozDGoJApwBgEsgc5EOisLen_ZNiW1",
      category: "college",
    },
    {
      title: "FocusFlow",
      description: "Pomodoro Timer Mobile App using React Native.",
      imgUrl: projImg8,
      link: "https://github.com/BlainBlain/FocusFlow",
      category: "course",
    },
    {
      title: "MoguMobile",
      description: "Food Ordering App using React Native.",
      imgUrl: projImg9,
      link: "https://github.com/BlainBlain/MoguMobile",
      category: "course",
    },
  ];

  const filterProjectsByCategory = (category) => {
    return projects.filter((project) => project.category === category);
  };

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  <p>
                    Here are my accomplished projects so far, showcasing my
                    skills in coding, automation, and database integration. They
                    include personal projects I’ve developed independently,
                    including original builds and enhanced forks, team-based
                    projects from college, and projects built while following
                    courses.
                  </p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="personal">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="personal">Personal</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="college">College</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="course">Courses</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content
                      id="slideInUp"
                      className={
                        isVisible ? "animate__animated animate__slideInUp" : ""
                      }
                    >
                      <Tab.Pane eventKey="personal">
                        <Row>
                          {filterProjectsByCategory("personal").map(
                            (project, index) => (
                              <ProjectCard key={index} {...project} />
                            ),
                          )}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="college">
                        <Row>
                          {filterProjectsByCategory("college").map(
                            (project, index) => (
                              <ProjectCard key={index} {...project} />
                            ),
                          )}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="course">
                        <Row>
                          {filterProjectsByCategory("course").map(
                            (project, index) => (
                              <ProjectCard key={index} {...project} />
                            ),
                          )}
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img
        className="background-image-right"
        src={colorSharp2}
        alt="background"
      />
    </section>
  );
};
